
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { getCompanyAllActiveRoles, companyAllActiveRoles } from '@/utils/role';

type IRoleInfo = IRole.IResponse.IRoleInfo;

@Component
export default class SelectRole extends Vue {
  @Prop({default: () => []}) private excludeRoleIds!: string[];
  private defaultOptions: IRoleInfo[] = [];
  get roleOptions() {
    return this.defaultOptions.filter((role) => !this.excludeRoleIds.includes(role.id));
  }
  private created() {
    this.initOptions();
  }
  private initOptions() {
    if (companyAllActiveRoles.length === 0) {
      getCompanyAllActiveRoles().then(() => {
        this.defaultOptions = companyAllActiveRoles;
      }).catch((err) => {
        this.$message.warning(err);
      });
    } else {
      this.defaultOptions = companyAllActiveRoles;
    }
  }
  // 处理选项改变
  private handleChange(value: string | string[]) {
    this.$emit('change', value);
  }
}
